import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "dialog-icon",
  role: "img",
  "aria-label": "check-circle"
};
import { Modal as AModal, ConfigProvider } from 'ant-design-vue';
import { ref, computed, watch, watchEffect, useAttrs, unref, h } from 'vue';
import { useDraggable } from '@vueuse/core';
import { QuestionCircleFilled, CheckCircleFilled, WarningFilled, InfoCircleFilled, CloseCircleFilled } from '@ant-design/icons-vue';
import theme, { colors } from '@/antvTheme.js';
import locale from 'ant-design-vue/es/locale/zh_CN';
import 'dayjs/locale/zh-cn';
import dayjs from 'dayjs';
import siteLogo from '@/assets/images/logo.png';
const __default__ = {
  name: 'XDialog'
};
export default /*@__PURE__*/Object.assign(__default__, {
  props: {
    title: {
      type: String,
      default: ''
    },
    open: {
      type: [Boolean, Object],
      default: false
    },
    compProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['update:open', 'afterClose', 'ok', 'cancel'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    dayjs.locale('zh-cn');
    const componentSize = ref('middle');
    const appTheme = ref({
      ...theme
    });
    const props = __props;
    const isOpen = ref(unref(props.open));
    const modalRef = ref();
    const modalTitleRef = ref();
    const allAttrs = useAttrs();
    const dialogCompRef = ref();
    const {
      content,
      ...attrs
    } = allAttrs;
    const {
      x,
      y,
      isDragging
    } = useDraggable(modalTitleRef);
    const emit = __emit;
    const handleAfterClose = () => {
      emit('update:open', false);
      emit('afterClose');
    };
    watch(() => props.open, val => {
      isOpen.value = unref(val);
    });
    const dialogIcons = {
      default: () => h('img', {
        src: siteLogo,
        alt: 'kpi-cloud',
        style: {
          width: '22px',
          height: '22px',
          border: 'none'
        }
      }),
      info: () => h(InfoCircleFilled, {
        style: {
          color: colors.infoColor,
          fontSize: '22px'
        }
      }),
      warning: () => h(WarningFilled, {
        style: {
          color: colors.warningColor,
          fontSize: '22px'
        }
      }),
      error: () => h(CloseCircleFilled, {
        style: {
          color: colors.errorColor,
          fontSize: '22px'
        }
      }),
      success: () => h(CheckCircleFilled, {
        style: {
          color: colors.successColor,
          fontSize: '22px'
        }
      }),
      confirm: () => h(QuestionCircleFilled, {
        style: {
          color: colors.confirmColor,
          fontSize: '22px'
        }
      })
    };
    const icon = computed(() => {
      return dialogIcons[attrs.type] || dialogIcons.default;
    });
    const handleOk = e => {
      emit('ok');
    };
    const handleCancel = e => {
      emit('cancel');
    };
    __expose({
      open: () => {
        isOpen.value = true;
      },
      close: () => {
        isOpen.value = false;
      }
    });
    const startX = ref(0);
    const startY = ref(0);
    const startedDrag = ref(false);
    const transformX = ref(0);
    const transformY = ref(0);
    const preTransformX = ref(0);
    const preTransformY = ref(0);
    const dragRect = ref({
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    });
    watch([x, y], () => {
      if (!startedDrag.value) {
        startX.value = x.value;
        startY.value = y.value;
        const bodyRect = document.body.getBoundingClientRect();
        const titleRect = modalTitleRef.value.getBoundingClientRect();
        dragRect.value.right = bodyRect.width - titleRect.width;
        dragRect.value.bottom = bodyRect.height - titleRect.height;
        preTransformX.value = transformX.value;
        preTransformY.value = transformY.value;
      }
      startedDrag.value = true;
    });
    watch(isDragging, () => {
      if (!isDragging) {
        startedDrag.value = false;
      }
    });
    watchEffect(() => {
      if (startedDrag.value) {
        transformX.value = preTransformX.value + Math.min(Math.max(dragRect.value.left, x.value), dragRect.value.right) - startX.value;
        transformY.value = preTransformY.value + Math.min(Math.max(dragRect.value.top, y.value), dragRect.value.bottom) - startY.value;
      }
    });
    watch([transformX, transformY], () => {
      if (dialogCompRef.value) {
        dialogCompRef.value.style.transform = `translate(${transformX.value}px, ${transformY.value}px)`;
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_unref(AModal), _mergeProps({
        ref_key: "modalRef",
        ref: modalRef,
        open: isOpen.value,
        "onUpdate:open": _cache[0] || (_cache[0] = $event => isOpen.value = $event),
        "wrap-style": {
          overflow: 'hidden'
        }
      }, attrs, {
        "after-close": handleAfterClose,
        onOk: handleOk,
        onCancel: handleCancel
      }), _createSlots({
        title: _withCtx(() => [_createElementVNode("span", _hoisted_1, [_createVNode(_unref(icon))]), _createElementVNode("span", {
          ref_key: "modalTitleRef",
          ref: modalTitleRef,
          class: "dialog-title",
          style: {
            "width": "100%",
            "cursor": "move"
          }
        }, [_renderSlot(_ctx.$slots, "title", {}, () => [_createTextVNode(_toDisplayString(__props.title), 1)])], 512)]),
        modalRender: _withCtx(({
          originVNode
        }) => [_createElementVNode("div", {
          ref_key: "dialogCompRef",
          ref: dialogCompRef,
          class: "dialog-content"
        }, [_createVNode(_unref(ConfigProvider), {
          theme: appTheme.value,
          locale: _unref(locale),
          "component-size": componentSize.value
        }, {
          default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(originVNode)))]),
          _: 2
        }, 1032, ["theme", "locale", "component-size"])], 512)]),
        default: _withCtx(() => [_renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps(__props.compProps)), () => [_createTextVNode(_toDisplayString(_unref(content)), 1)])]),
        _: 2
      }, [_renderList(_ctx.$slots, (_, key) => {
        return {
          name: key,
          fn: _withCtx(scope => [['title', 'modalRender'].indexOf(key) === -1 ? _renderSlot(_ctx.$slots, key, _mergeProps({
            key: key
          }, scope)) : _createCommentVNode("", true)])
        };
      })]), 1040, ["open"])]);
    };
  }
});